export default __webpack_public_path__ + "static/media/icon-waiting.feb20a1f.svg";